import { defineEvent, type EventPayload } from '@nexus/core';
import { z } from 'zod';
import { INSPECTION_STATUSES } from './types';

// Events carry IDs, never personal data: subscribers load what they need through the public API.

export const inspectionCreated = defineEvent(
  'sigeko.inspection.created',
  z.object({ inspectionId: z.uuid() }),
);
export type InspectionCreated = EventPayload<typeof inspectionCreated>;

export const inspectionUpdated = defineEvent(
  'sigeko.inspection.updated',
  z.object({ inspectionId: z.uuid() }),
);
export type InspectionUpdated = EventPayload<typeof inspectionUpdated>;

/** Started, completed with the report sent, or reopened. */
export const inspectionStatusChanged = defineEvent(
  'sigeko.inspection.status-changed',
  z.object({ inspectionId: z.uuid(), status: z.enum(INSPECTION_STATUSES) }),
);
export type InspectionStatusChanged = EventPayload<typeof inspectionStatusChanged>;

export const inspectionDeleted = defineEvent(
  'sigeko.inspection.deleted',
  z.object({ inspectionId: z.uuid() }),
);
export type InspectionDeleted = EventPayload<typeof inspectionDeleted>;
